import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { IEntity } from "@/lib/utility/data/entity.interface";
import aiService from "@/services/mrfiktiv/services/aiService";
import {
  MrfiktivOpenAiPartnerViewModelGen,
  MrfiktivOpenAiUsageViewModelGen,
  MrfiktivReferenceGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ITimestamp, Timestamp } from "./timestamp.entity";
import { AiResultDataAccessLayer } from "@/store/modules/access-layers/ai-result.access-layer";

@IsFilterable
class AiResultBase implements IEntity<IAiResult, never>, MrfiktivOpenAiPartnerViewModelGen {
  loading = false;

  @FilterConfig({
    type: FilterTypes.OBJECT_ID,
    displayName: "objects.aiResult.id"
  })
  id: string;

  @FilterConfig({
    type: FilterTypes.OBJECT_ID,
    displayName: "objects.aiResult.partnerId"
  })
  partnerId: string;

  usage: MrfiktivOpenAiUsageViewModelGen;

  content?: object;

  refs: MrfiktivReferenceGen[];

  @FilterConfig({
    type: Timestamp
  })
  timestamp: ITimestamp;

  constructor(data: Partial<MrfiktivOpenAiPartnerViewModelGen>) {
    this.id = data.id || "";
    this.partnerId = data.partnerId || "";
    this.usage = data.usage || { total_tokens: 0 };
    this.content = data.content;
    this.refs = data.refs || [];
    this.timestamp = new Timestamp(data.timestamp);
  }

  map(data: MrfiktivOpenAiPartnerViewModelGen): void {
    this.id = data.id || "";
    this.partnerId = data.partnerId || "";
    this.usage = data.usage || { total_tokens: 0 };
    this.content = data.content;
    this.refs = data.refs || [];
    this.timestamp = new Timestamp(data.timestamp);
  }

  async fetch(): Promise<this> {
    this.loading = true;
    try {
      const res = await aiService.getOne(this.partnerId, this.id);
      this.map(res);
      AiResultDataAccessLayer.set(this);
    } catch (e) {
      this.loading = false;
      AiResultDataAccessLayer.delete(this);
      throw e;
    }
    this.loading = false;

    return this;
  }

  async create(): Promise<this> {
    throw new Error("Not supported");
  }

  async updatePartial(): Promise<this> {
    throw new Error("Not supported");
  }

  async update(): Promise<this> {
    throw new Error("Not supported");
  }

  async delete(): Promise<void> {
    throw new Error("Not supported");
  }
}

type IAiResult = AiResultBase;
const AiResult = Filter.createForClass(AiResultBase);

export { IAiResult, AiResult };
